export function setHtmlLanguage(lang: string) {
	document.documentElement.lang = lang;

	updateMetaTags(lang);
}

function updateMetaTags(lang: string) {
	const metaTags = [
		{ name: "Content-Language", content: lang },
		{ property: "og:locale", content: lang.replace("-", "_") },
	];

	metaTags.forEach(({ name, property, content }) => {
		const selector = name
			? `meta[name="${name}"]`
			: `meta[property="${property}"]`;

		let tag = document.querySelector(selector) as HTMLMetaElement | null;

		if (!tag) {
			tag = document.createElement("meta");

			if (name) {
				tag.setAttribute("name", name);
			}

			if (property) {
				tag.setAttribute("property", property);
			}

			document.head.appendChild(tag);
		}

		tag.setAttribute("content", content);
	});
}
